<app-breadcrumb [title]="'Application Details'"></app-breadcrumb>
<div class="container-fluid my-5">
    <div class="card-header">
        <div class="d-flex align-items-center justify-content-between">
            <h3 class="h6 fw-bold mb-0">Employee Profile</h3>
            <a [routerLink]="['/region/employee-profile']" class="btn btn-outline-primary">Cancel</a>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <app-loader [show]="skeleton"></app-loader>
            <div *ngIf="setting?.financialYearId == financialYearId">
                <div *ngIf="profile">
                    <app-employee-profile [profile]="profile" [transferRequest]="transferRequest" [isEdit]="false">
                    </app-employee-profile>

                    <div class="mb-3 d-flex justify-content-start" *ngIf="profile">
                        <span class="fw-bold mr-2">Claimed Category:</span>
                        <span [innerHtml]="getCategories(profile)"></span>
                    </div>

                    <div class="mb-3 d-flex justify-content-start" *ngIf="profileStatus">
                        <span class="fw-bold mr-2">Eligible Category (Approved By Principal):</span>
                        <span [innerHtml]="getPrincipalEligibleCategory(profileStatus, profile)"></span>
                    </div>
                    <p *ngIf="profileStatus">Principal Remark: {{ profileStatus.principalRemark }}</p>

                    <div class="mb-3 d-flex justify-content-start" *ngIf="profileStatus">
                        <span class="fw-bold mr-2">Eligible Category (Approved By RO):</span>
                        <span [innerHtml]="getROEligibleCategory(profileStatus, profile)"></span>
                    </div>
                    <p *ngIf="profileStatus">RO Remark: {{ profileStatus.roRemark }}</p>

                    <div class="mb-3 d-flex justify-content-start"
                        *ngIf="profileStatus==null && transferRequest.isTransfer">
                        <span class="fw-bold mr-2">Eligible Category (Approved By Principal):</span>
                        <span [innerHtml]="getPrincipalEligiblePlaneCategory(profile)"></span>
                    </div>

                    <div class="mb-3 d-flex justify-content-start"
                        *ngIf="profileStatus==null && transferRequest.isTransfer">
                        <span class="fw-bold mr-2">Eligible Category (Approved By RO):</span>
                        <span [innerHtml]="getROEligiblePlaneCategory(profile)"></span>
                    </div>

                </div>
            </div>
            <div *ngIf="setting?.financialYearId != financialYearId">
                <ng-container *ngIf="profileLog; else noData">
                <div *ngIf="profileLog">
                    <app-employee-profile [profileLog]="profileLog" [transferRequestLog]="transferRequestLog" [isEdit]="false">
                    </app-employee-profile>

                    <div class="mb-3 d-flex justify-content-start" *ngIf="profileLog">
                        <span class="fw-bold mr-2">Claimed Category:</span>
                        <span [innerHtml]="getCategoriesLog(profileLog)"></span>
                    </div>

                    <div class="mb-3 d-flex justify-content-start" *ngIf="profileStatusLog">
                        <span class="fw-bold mr-2">Eligible Category (Approved By Principal):</span>
                        <span [innerHtml]="getPrincipalEligibleCategoryLog(profileStatusLog, profileLog)"></span>
                    </div>
                    <p *ngIf="profileStatusLog">Principal Remark: {{ profileStatusLog?.principalRemark }}</p>

                    <div class="mb-3 d-flex justify-content-start" *ngIf="profileStatusLog">
                        <span class="fw-bold mr-2">Eligible Category (Approved By RO):</span>
                        <span [innerHtml]="getROEligibleCategoryLog(profileStatusLog, profileLog)"></span>
                    </div>
                    <p *ngIf="profileStatusLog">RO Remark: {{ profileStatusLog?.roRemark }}</p>

                    <div class="mb-3 d-flex justify-content-start"
                        *ngIf="profileStatusLog==null && transferRequestLog?.isTransfer">
                        <span class="fw-bold mr-2">Eligible Category (Approved By Principal):</span>
                        <span [innerHtml]="getPrincipalEligiblePlaneCategoryLog(profileLog)"></span>
                    </div>

                    <div class="mb-3 d-flex justify-content-start"
                        *ngIf="profileStatusLog==null && transferRequestLog?.isTransfer">
                        <span class="fw-bold mr-2">Eligible Category (Approved By RO):</span>
                        <span [innerHtml]="getROEligiblePlaneCategoryLog(profileLog)"></span>
                    </div>

                </div>
                </ng-container>
                <ng-template #noData>
                    <div *ngIf="profile">
                        <app-employee-profile [profile]="profile" [transferRequest]="transferRequest" [isEdit]="false">
                        </app-employee-profile>
    
                        <div class="mb-3 d-flex justify-content-start" *ngIf="transferRequest">
                            <span class="fw-bold mr-2">Claimed Category:</span>
                            <span [innerHtml]="getCategories(profile)"></span>
                        </div>
    
                        <div class="mb-3 d-flex justify-content-start" *ngIf="profileStatus">
                            <span class="fw-bold mr-2">Eligible Category (Approved By Principal):</span>
                            <span [innerHtml]="getPrincipalEligibleCategory(profileStatus, profile)"></span>
                        </div>
                        <p *ngIf="profileStatus">Principal Remark: {{ profileStatus.principalRemark }}</p>
    
                        <div class="mb-3 d-flex justify-content-start" *ngIf="profileStatus">
                            <span class="fw-bold mr-2">Eligible Category (Approved By RO):</span>
                            <span [innerHtml]="getROEligibleCategory(profileStatus, profile)"></span>
                        </div>
                        <p *ngIf="profileStatus">RO Remark: {{ profileStatus.roRemark }}</p>
    
                        <div class="mb-3 d-flex justify-content-start"
                            *ngIf="profileStatus==null && transferRequest.isTransfer">
                            <span class="fw-bold mr-2">Eligible Category (Approved By Principal):</span>
                            <span [innerHtml]="getPrincipalEligiblePlaneCategory(profile)"></span>
                        </div>
    
                        <div class="mb-3 d-flex justify-content-start"
                            *ngIf="profileStatus==null && transferRequest.isTransfer">
                            <span class="fw-bold mr-2">Eligible Category (Approved By RO):</span>
                            <span [innerHtml]="getROEligiblePlaneCategory(profile)"></span>
                        </div>
    
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>